import { useState, useRef } from "react";
import Config from "../../Config";
import PlTitle from "../../elements/PlTitle";
import Review from "./Review";
import ReviewYear from "./ReviewYear";
import ToExport from "./ToExport";
import Saldo from "./Saldo";
import Sms from "./Sms";


function List(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [tab, setTab] = useState(null);

    const [itemSelected, setItemSelected] = useState(1);

    const [fraza,setFraza] = useState("");



    const clickTab = (e) => {

        var t = e.target.getAttribute("atr-tab");
        setItemSelected(t);
    }


    const onSearch= (e) => {
        var x = e.target.value;

        x = x.toLowerCase();

        setFraza(x);

        if(itemSelected != 2)
        {
            setItemSelected(2);
        }
    }






    var cssTab1 = "";
    var cssTab2 = "";
    var cssTab3 = "";
    var cssTab4 = "";
    var cssTab5 = "";
    var cssTab6 = "";
    var cssTab7 = "";

    if(itemSelected == 1) cssTab1 = " xActive ";
    if(itemSelected == 2) cssTab2 = " xActive ";
    if(itemSelected == 3) cssTab3 = " xActive ";
    if(itemSelected == 4) cssTab4 = " xActive ";
    if(itemSelected == 5) cssTab5 = " xActive ";
    if(itemSelected == 6) cssTab6 = " xActive ";
    if(itemSelected == 7) cssTab7 = " xActive ";

    return <div className="view_content">

                          


                <div className="big_search">
                      <input type="text" value={fraza} onChange={onSearch} placeholder="Nazwa raportu / fraza: " />
                </div>        

                <div className="xTabs">
                        <div className={"xItem " + cssTab1 } atr-tab="1" onClick={clickTab}  >Miesiąc</div>
                        <div className={"xItem " + cssTab5 } atr-tab="5" onClick={clickTab}  >Rok</div>
                        <div className={"xItem " + cssTab6 } atr-tab="6" onClick={clickTab}  >Salda rodziców</div>
                        <div className={"xItem " + cssTab7 } atr-tab="7" onClick={clickTab}  >SMSy</div>
                        <div className={"xItem " + cssTab2 } atr-tab="2" onClick={clickTab}  >Zbiór raportów</div>                         
                        <div className={"xEmpty "  }>&nbsp;</div>
                </div>

                {
                    itemSelected == 1 &&
                    <Review  userData={props.userData} mainView={props.mainView} />
                }
  
                {
                    itemSelected == 5 &&
                    <ReviewYear  userData={props.userData} mainView={props.mainView} />
                }     
              
                {
                    itemSelected == 6 &&
                    <Saldo  userData={props.userData} mainView={props.mainView} />                                
                }


                {
                     itemSelected == 7   &&
                    <Sms  userData={props.userData} mainView={props.mainView}  type="all" search={fraza}   />
                }  


                {
                     itemSelected == 2   &&
                    <ToExport  userData={props.userData} mainView={props.mainView}  type="all" search={fraza}   />
                }  

                {
                     itemSelected == 3   &&
                    <ToExport  userData={props.userData} mainView={props.mainView}  type="public" search={fraza}   />
                } 

                {
                     itemSelected == 4   &&
                    <ToExport  userData={props.userData} mainView={props.mainView}  type="private"  search={fraza}  />
                } 



    </div>
}


export default List;